import { Mixpanel } from '@/lib/mixpanel';
import type { TrackPayload } from '@/types';
import { useCallback } from 'react';

export const useActionsTrack = () => {
  const trackAction = useCallback((payload: TrackPayload) => {
    Mixpanel.track('User Action', {
      timestamp: new Date().toISOString(),
      ...payload,
      ...payload.extra,
    });
  }, []);

  return { trackAction };
};
